import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/image/vipImg/popup_vip_open_head_short.png'
import _imports_1 from '@/assets/image/vipImg/crown.png'


const _hoisted_1 = { class: "pay-success" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "dialog-title" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "bg"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "crown"
}, null, -1)
const _hoisted_7 = { class: "dialog-tip" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "paypal-tip"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1)
const _hoisted_11 = { class: "flex-ter-cen" }

import { t } from '@/plugins/i18n'
import { ref, watch, computed } from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'
import CheckRadio from '@/components/checkRadio/index.vue'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'close'],
  setup(__props, { expose, emit }) {

const props = __props
const store = useStore()


const close = () => {
  emit('update:visible', false)
  emit('close', info.value.vipName)
}
const info = ref({})
const open = (obj: any) => {
  info.value = obj
}

expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "custom-class": "pay-success-dialog",
      "model-value": __props.visible,
      "append-to-body": "",
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(info.value.title), 1),
            _hoisted_5,
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "tip1",
              innerHTML: info.value.text
            }, null, 8, _hoisted_8),
            (info.value.isPaypal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(_unref(t)('为了不影响您的后续使用，请保持PayPal内开启自动续费。')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            class: "btn",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('知道了')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})